module.exports = __webpack_public_path__ + "img/ava-2.d0898cf1.webp";